module.exports = __webpack_public_path__ + "img/a2-s39.e7462dff.jpg";